import { Link, createFileRoute } from "@tanstack/react-router";
import { EnvelopeIcon } from "@heroicons/react/20/solid";
import Footer from "#/components/footer/footer";
import { metadataToHead } from "#/lib/seo";

const ForgotPassword = () => {
  return (
    <>
      <main>
        <div className="flex min-h-screen flex-col justify-center py-12 sm:px-6 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-md">
            <img
              className="mx-auto h-12 w-auto"
              src="/roamdoc-logo.png"
              alt="Roamdoc logo"
              width={256}
              height={102}
            />
            <h2 className="mt-6 text-center text-3xl font-extrabold text-sky-600">
              Reset your password
            </h2>
          </div>

          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div className="bg-white px-4 py-8 shadow sm:rounded-lg sm:px-10">
              <form className="space-y-6" action="#" method="POST">
                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Email address
                  </label>
                  <div className="mt-1">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      required
                      className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-sky-500 focus:outline-none focus:ring-sky-500 sm:text-sm"
                    />
                  </div>
                </div>

                <div>
                  <button
                    type="submit"
                    className="group relative flex w-full justify-center rounded-md border border-transparent bg-sky-600 px-4 py-2 text-sm font-medium text-white hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                  >
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                      <EnvelopeIcon
                        className="h-5 w-5 text-sky-500 group-hover:text-sky-400"
                        aria-hidden="true"
                      />
                    </span>
                    Send reset link
                  </button>
                </div>
              </form>

              <div className="mt-6 text-center text-sm">
                <Link
                  to="/account/login"
                  className="font-medium text-sky-600 hover:text-sky-500"
                >
                  Back to login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ForgotPassword;

export const metadata = {
  title: "Reset Password • Roamdoc",
  description: "Reset the password for your Roamdoc account.",
  icons: [{ rel: "icon", url: "/favicon.ico" }],
  openGraph: {
    images: ["https://www.roamdoc.com/og-image.png"],
  },
  alternates: {
    canonical: `https://www.roamdoc.com/account/reset-password`,
  },
};

export const Route = createFileRoute("/account/reset-password/")({
  component: ForgotPassword,
  head: () => metadataToHead(metadata),
});
